import * as React from 'react';

interface Props extends React.HTMLProps<SVGSVGElement> {}

const Times = (props: Props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="26"
        viewBox="0 0 33 26"
        {...props}
    >
        <g
            fill="none"
            fillRule="evenodd"
            stroke="#1800FF"
            strokeLinecap="square"
            strokeWidth="3.5"
        >
            <path d="M17.79 7.5L7 18.29M17.79 18.79L7 8" />
        </g>
    </svg>
);

export { Times };
